import { useEffect } from 'react';
import { onStart, onEnd } from '../helpers';

const useEventListeners = (carouselRef, updateEventData) => {
  useEffect(() => {
    const eventHandlers = [
      ['touchstart', onStart],
      ['touchend', onEnd],
      ['mousedown', onStart],
      ['mouseup', onEnd]
    ];

    eventHandlers.forEach(([event, handler]) => {
      carouselRef.current.addEventListener(event, e =>
        handler(e, updateEventData)
      );
    });

    return () => {
      eventHandlers.forEach(([event, handler]) => {
        carouselRef.current.removeEventListener(event, e =>
          handler(e, updateEventData)
        );
      });
    };
  }, []);
};

export default useEventListeners;
